<template>
  <div class="modes-carousel">
    <div class="content">
      <img
        src="../../assets/images/icons/newhome/model1.png"
        v-show="currentIndex === 0"
        key="item-0"
      />
      <img
        src="../../assets/images/icons/newhome/model2.png"
        v-show="currentIndex === 1"
        key="item-1"
      />
      <img
        src="../../assets/images/icons/newhome/model3.png"
        v-show="currentIndex === 2"
        key="item-2"
      />
    </div>
    <div class="smalls">
      <div :class="{ item: true, active: 0 === currentIndex }">
        <img src="../../assets/images/icons/newhome/model_small1.png" />
      </div>
      <div :class="{ item: true, active: 1 === currentIndex }">
        <img src="../../assets/images/icons/newhome/model_small2.png" />
      </div>
      <div :class="{ item: true, active: 2 === currentIndex }">
        <img src="../../assets/images/icons/newhome/model_small3.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModesCarousel",
  props: {
    visible: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.startInterval();
      } else {
        this.currentIndex = 0;
        clearInterval(this.intervalId);
      }
    },
  },
  mounted() {
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    startInterval() {
      this.intervalId = setInterval(this.nextCategory, 2200);
    },
    nextCategory() {
      this.currentIndex = (this.currentIndex + 1) % 3;
    },
  },
};
</script>

<style scoped lang="less">
.modes-carousel {
  width: 600px;
  height: 572px;
  display: flex;
  justify-content: space-between;
  .content {
    width: 429px;
    border-radius: 16px;
    overflow: hidden;
  }
  .smalls {
    width: 140px;
  }
}
.smalls {
  .item {
    width: 140px;
    width: 140px;
    border-radius: 12px;
    background-color: #fff;
    transition: all 0.15s;
    margin-bottom: 10px;
    display: flex;
    &.active {
      border: 4px solid #8873ff;
    }
  }
}

.fadeinner-enter-active,
.fadeinner-leave-active {
  transition: opacity 0.15s;
}

.fadeinner-enter,
.fadeinner-leave-to {
  opacity: 0;
}

/* 小于等于1440px时应用的样式 */
@media (max-width: 1440px) {
  .modes-carousel {
    width: 437px;
    height: 417px;
    .content {
      width: 313px;
    }
    .smalls {
      width: 102px;
    }
  }
  .smalls {
    .item {
      width: 102px;
      height: 102px;
    }
  }
}
</style>
